import { AppConfig } from "@Core/config/app-config";
import { AuthService } from "@Services/auth.service";
import { OAuthModuleConfig, OAuthStorage } from "angular-oauth2-oidc";

/**
 * Factory function for OAuthStorage.
 * Salva automaticamente i token sul local storage.
 * @returns {OAuthStorage} - Local storage instance
 */
export function storageFactory(): OAuthStorage {
  return localStorage;
}

/**
 * Initializes KeyCloak Configuration
 * @property {AuthService} authSvc - AuthService instance
 */
export function initKeyCloakConfig(authSvc: AuthService) {
  return () => {
    return authSvc.runInitialLoginSequence();
  };
}

export function oauthModuleConfigFactory(config: AppConfig): OAuthModuleConfig {
  return {
    resourceServer: {
      allowedUrls: [
        'http://adarte-svil.ministerocultura.gov.it/smnadarte-integration-app-web/api/app',
        'http://localhost:4200',
        `${config.ssotApiUrl}/v1/personal` // Iniettato dinamicamente
      ],
      sendAccessToken: true,
    },
  };
}

